import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=57468743&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57468743')) {
      api.createRecord('57468743', component.options)
    } else {
      api.reload('57468743', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=57468743&", function () {
      api.rerender('57468743', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Home.vue"
export default component.exports